(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvFileIcon', drvFileIcon);

    drvFileIcon.$inject = [];
    drvFileIconCtrl.$inject = ['SystemService'];

    /**
     * Shows a coloured file icon for the supplied extension or item type (e.g. 'docx', 'email', 'sms')
     * Available item types: 'email', 'sms', 'task'
     *
     * # Scope Properties
     * {string} extension - The file extension or item type.
     */
    function drvFileIcon() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvFileIconCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                extension: '<'
            },
            template:
                '<md-icon md-svg-icon="{{drvCtrl.icon.icon}}" ng-style="{\'fill\': drvCtrl.icon.iconColour}"></md-icon>'
        };
        return directive;
    }

    function drvFileIconCtrl(SystemService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        Object.defineProperty(drvCtrl, 'icon', { get: getIcon });

        function getIcon() {
            var icon = SystemService.getFileIcon(drvCtrl.extension);

            if (!_.isEqual(icon, getIcon.icon)) {
                getIcon.icon = icon;
            }

            return getIcon.icon;
        }
    }
})();